module.exports = __webpack_public_path__ + "static/media/basement.a98ea198.png";